<router-outlet></router-outlet>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="aliceblue" type="ball-fall" [fullScreen]="true"></ngx-spinner>
